import React from 'react'
import { connect } from 'react-redux'

import Navigator from '../../app/navigator'

import { TidewaysContext } from '../../app/context'
import { ActiveSlot } from '../../domain/ActiveSlot'
import { GraphEntity } from '../../domain/GraphEntity'
import Loading from '../../helper/loading'
import { ApplicationState } from '../../redux/ApplicationState'
import { OperationsGraphEntity } from '../../redux/operations/OperationsState'
import Graph from './graph'
import Tooltip from './tooltip'

interface OwnProps {
    loading: boolean
    data: GraphEntity | OperationsGraphEntity | null
    dataFixedTimezone?: string
}

interface StateProps {
    navigator: Navigator
    tidewaysContext: TidewaysContext
    parameters: { [key: string]: string }
}

interface State {
    activeSlot: ActiveSlot
}
type Props = OwnProps & StateProps

class TooltipGraph extends React.PureComponent<Props, State> {
    public static displayName = 'Graph'

    public state: State = {
        activeSlot: {
            timeIndex: null,
            mouse: null,
        },
    }
    public changeActiveSlot = activeSlot => this.setState({ activeSlot })

    public render() {
        const { tidewaysContext } = this.props
        const percentiles = {
            '50p': '50% Percentile',
            '90p': '90% Percentile',
            '95p': '95% Percentile',
            '99p': '99% Percentile',
            '99.9p': '99.9% Percentile',
            avg: 'Average',
            request: '95% Percentile',
            max: 'Maximum',
        }

        if (!this.props.data) {
            return (
                <div>
                    <Loading {...this.props} height={354} title="Response Times" />
                </div>
            )
        }

        return (
            <React.Fragment>
                <Graph {...this.props} data={this.props.data} changeActiveSlot={this.changeActiveSlot} />
                <Tooltip
                    data={this.props.data}
                    activeSlot={this.state.activeSlot}
                    percentileLabel={percentiles[this.props.parameters.type || '95p']}
                    downstreamEnabled={this.props.data.report.hasDownstream}
                    showAverages
                    parentSelector=".jquery-tooltip-reference"
                    showFailureDetails={tidewaysContext.hasFeature('response_time_target')}
                    showCrawlers={tidewaysContext.hasFeature('crawler_ratio')}
                />
            </React.Fragment>
        )
    }
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState, props: OwnProps) => {
    return {
        navigator: new Navigator(globalState.tidewaysContext.route),
        parameters: globalState.tidewaysContext.route.parameters,
        tidewaysContext: globalState.tidewaysContext,
    }
})(TooltipGraph)
